import React, { useRef, useEffect } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import { Alert } from '@material-ui/lab';
import ProtectedRoutes from './ProtectedRoutes';
import NotFound from '../pages/NotFound';
import PublicRoutes from './PublicRoutes';
import { ROUTES_DATA } from './RouteData';
import './Alertify.scss';
import Sidebar from '../components/SideBar';
import { songsStore } from '../store';

const Routes = () => {
  const location = useLocation();
  const audioRef = useRef(null);

  // Zustand Song Store
  const { currSongToPlay } = songsStore((state) => {
    return {
      currSongToPlay: state.currSongToPlay,
    };
  });

  useEffect(() => {
    audioRef?.current?.pause();
    if (!audioRef.current) {
      console.log('error');
      return;
    }

    // Check if the audio is currently playing before pausing
    if (!audioRef.current.paused) {
      audioRef.current.pause();
    }

    if (currSongToPlay && currSongToPlay.isPlaying) {
      audioRef.current.src = `${process.env.REACT_APP_MEDIA_URL}/${currSongToPlay?.song?.audio_track}`;
      audioRef.current.play();
    } else {
      audioRef.current.src = '';
    }
  }, [currSongToPlay]);

  // useEffect(() => {
  //   const { data } = _isAuthenticated();
  //   let refreshTokenInterval;

  //   if (data && data.token) {
  //     refreshTokenInterval = setInterval(() => {
  //       _refreshToken();
  //     }, 10000);
  //   }

  //   return () => {
  //     clearInterval(refreshTokenInterval);
  //   };
  // }, []);

  return (
    <section className="main-wrapper">
      <div id="alert-box-warpper" className="alert-wrapper-closed alert-main-wrapper">
        <Alert severity="">''</Alert>
      </div>
      {location.pathname === '/' ? (
        <Switch>
          {ROUTES_DATA.map((route, index) => {
            const { isProtected } = route;
            return isProtected ? <ProtectedRoutes {...route} key={index} /> : <PublicRoutes {...route} key={index} />;
          })}
          <Route path="*" component={NotFound} />
        </Switch>
      ) : (
        <div className="main">
          <Sidebar />
          <div className="leftPortion">
            <Switch>
              {ROUTES_DATA.map((route, index) => {
                const { isProtected } = route;
                return isProtected ? <ProtectedRoutes {...route} key={index} /> : <PublicRoutes {...route} key={index} />;
              })}
              <Route path="*" component={NotFound} />
            </Switch>
          </div>
        </div>
      )}

      <audio ref={audioRef} />
    </section>
  );
};

export default Routes;

